function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.3333 2.66669C12.4379 2.66669 13.3333 3.56212 13.3333 4.66669C13.3333 5.77125 12.4379 6.66669 11.3333 6.66669C10.6957 6.66669 10.1279 6.36841 9.76167 5.90381L7.25743 7.45266C7.30682 7.62662 7.33325 7.81023 7.33325 8.00002C7.33325 8.20367 7.30281 8.40022 7.24624 8.58535L9.73303 10.1334C10.0979 9.64762 10.6789 9.33335 11.3333 9.33335C12.4379 9.33335 13.3333 10.2288 13.3333 11.3334C13.3333 12.438 12.4379 13.3334 11.3333 13.3334C10.2287 13.3334 9.33325 12.438 9.33325 11.3334C9.33325 11.1223 9.36595 10.9189 9.42654 10.7279L6.94598 9.18309C6.58195 9.67849 5.99515 10 5.33325 10C4.22869 10 3.33325 9.10459 3.33325 8.00002C3.33325 6.89545 4.22869 6.00002 5.33325 6.00002C6.00878 6.00002 6.60609 6.33493 6.96818 6.84777L9.44173 5.31809C9.37143 5.1139 9.33325 4.89475 9.33325 4.66669C9.33325 3.56212 10.2287 2.66669 11.3333 2.66669Z",
  fill: "currentColor"
});

function SvgIconShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/iconShare.aac77f52.svg";
export { ForwardRef as ReactComponent };